import util, {getSvgPath} from "../util";

function updateSize($element, heightPercent, widthPercent, cfgHeight, cfgWidth) {
  $element.css('height', `${heightPercent}%`);
  $element.css('width', `${widthPercent}%`);

  $element.attr('data-inch-width', cfgWidth.in);
  $element.attr('data-inch-height', cfgHeight.in);

  $element.attr('data-px-width', cfgWidth.px);
  $element.attr('data-px-height', cfgHeight.px);
}

function getElements($element, cfgWidth, cfgHeight = {}) {
  const pxWidth = cfgWidth.in ? util.inchToPixel(cfgWidth.in) : cfgWidth.px;
  const pxHeight = cfgHeight.in ? util.inchToPixel(cfgHeight.in) : cfgHeight.px;

  const $elements = Array.isArray($element) ? $element : [$element];

  const $svgs = $elements.map($element => $element.find('.svg-content').find('svg'));
  const $paths = $elements.map($element => getSvgPath($element));

  return {pxWidth, pxHeight, $elements, $svgs, $paths};
}

export function changeSquareSize($element, cfgWidth, cfgHeight) {
  const {pxWidth, pxHeight, $elements, $svgs, $paths} = getElements($element, cfgWidth, cfgHeight);

  function resize(width, height) {
    const heightPercent = util.pixelToPercent(height, util.getActiveDimensions().height);
    const widthPercent = util.pixelToPercent(width, util.getActiveDimensions().width);

    $elements.forEach(($element, idx) => {
      const strokeWidth = util.getStrokeWidth($paths[idx].attr('data-original-stroke-width'), util.getActiveDimensions().width);

      $svgs[idx].attr('viewBox', `0 0 ${width} ${height}`);
      $paths[idx].attr({
        width: width - 12,
        height: height - 12,
        'stroke-width': strokeWidth
      });

      updateSize($element, heightPercent, widthPercent, cfgHeight, cfgWidth);
    });
  }

  const redo = () => resize(pxWidth, pxHeight);
  redo();
}

export function changeCircleSize($element, cfgWidth, cfgHeight) {
  const {pxWidth, pxHeight, $elements, $svgs, $paths} = getElements($element, cfgWidth, cfgHeight);

  function resize(width, height) {
    const heightPercent = util.pixelToPercent(height, util.getActiveDimensions().height);
    const widthPercent = util.pixelToPercent(width, util.getActiveDimensions().width);

    $elements.forEach(($element, idx) => {
      const strokeWidth = util.getStrokeWidth($paths[idx].attr('data-original-stroke-width'), util.getActiveDimensions().width);

      $svgs[idx].attr('viewBox', `0 0 ${width} ${height}`);
      $paths[idx].attr({
        cx: width / 2,
        cy: height / 2,
        rx: width / 2 - 7,
        ry: height / 2 - 7,
        'stroke-width': strokeWidth
      });

      updateSize($element, heightPercent, widthPercent, cfgHeight, cfgWidth);
    });
  }

  const redo = () => resize(pxWidth, pxHeight);
  redo();
}

export function changeLineSize($element, cfgWidth) {
  const {pxWidth, $elements, $svgs, $paths} = getElements($element, cfgWidth);

  function resize(width) {
    const widthPercent = util.pixelToPercent(width, util.getActiveDimensions().width);

    $elements.map(($element, idx) => {
      const strokeWidth = util.getStrokeWidth($paths[idx].attr('data-original-stroke-width'), util.getActiveDimensions().width);

      $svgs[idx].attr('viewBox', `0 0 ${width} 16`);
      $paths[idx].attr({x1: 0, x2: width, 'stroke-width': strokeWidth});
      $svgs[idx].css('height', '100%');


      $element.css('width', `${widthPercent}%`);
      $element.attr('data-inch-width', cfgWidth.in);
      $element.attr('data-px-width', cfgWidth.px);
    });
  }

  const redo = () => resize(pxWidth);
  redo();
}
